import LinkButton from "./LinkButton";

export default LinkButton;
